module.exports = __webpack_public_path__ + "img/konsultasi.3147ee80.svg";